import { LoadingButton } from "@mui/lab";
import { IResourceComponentsProps } from "@refinedev/core";
import { List } from "@refinedev/mui";
import React from "react";

import { usePostReindexCryptors } from "@/api/prediction.api";

export const AiTraining: React.FC<IResourceComponentsProps> = () => {
  const postReindexCryptors = usePostReindexCryptors();

  return (
    <List title="Entrainement de l'IA">
      <LoadingButton
        variant="contained"
        onClick={() => postReindexCryptors.mutate()}
        loading={postReindexCryptors.isPending}
      >
        {"Reindexer les cryptors"}
      </LoadingButton>
    </List>
  );
};
